"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
require("./PlanSelection.scss");
const snap_ui_1 = require("@teamsnap/snap-ui");
const icons_1 = require("components/common/icons");
const React = __importStar(require("react"));
const PlanSelection = ({ plans, selectedPlan, onPlanSelect }) => {
    return (React.createElement("fieldset", { className: "sui-flex sui-gap-2 sui-mb-2 sui-flex-col" }, plans.map((plan) => (React.createElement(snap_ui_1.BorderedRadio, { "data-testid": `plan-${plan.type}`, selected: selectedPlan === plan.type, className: `plan-selection ${selectedPlan === plan.type ? 'plan-selection-selected' : ''}`, onSelect: () => onPlanSelect(plan.type), key: plan.type },
        React.createElement("div", { className: "sui-flex sui-items-center sui-gap-2 sui-justify-between sui-flex-1" },
            React.createElement("div", { className: "sui-pt-1 sui-ml-1" },
                React.createElement("div", { className: "sui-text-desktop-8 sui-font-bold" }, plan.price),
                plan.trial && React.createElement("div", { className: "sui-text-gray-40 sui-mt-1" }, plan.trial)),
            plan.badgeLabel && (React.createElement("div", { className: "sui-self-baseline sui-mr-1" },
                React.createElement("div", { className: "sui-px-1 sui-my-0.5 sui-text-skyblue-30 sui-font-semibold sui-bg-skyblue-90 sui-rounded-[10px] sui-flex sui-items-center" },
                    React.createElement(icons_1.Crown, null),
                    " Best deal")))))))));
};
exports.default = PlanSelection;
